<template>
  <div class="warning-page">
    <div class="search-box">
      <el-form
        inline
        :model="formInline"
        class="demo-form-inline"
        label-width="120px"
      >
        <el-form-item label="所属乡镇">
          <el-select clearable class="form-select" popper-class="form-select-dropdown" :popper-append-to-body="false" v-model="formInline.town" placeholder="请选择">
            <el-option
              v-for="item in townshipList"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="状态">
          <el-select clearable class="form-select" popper-class="form-select-dropdown" :popper-append-to-body="false" v-model="formInline.status" placeholder="请选择">
            <el-option
              label="报警解除"
              :value="5">
            </el-option>
            <el-option
              label="报警关闭"
              :value="4">
            </el-option>
            <el-option
              label="申诉通过"
              :value="6">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <div class="text-justify" slot="label">日期</div>
          <el-date-picker
            class="form-time-select"
            v-model="date"
            type="daterange"
            value-format="yyyy-MM-dd"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="changeDate"
            popper-class="form-time-select-dropdown form-time-picker-dropdown"
          ></el-date-picker>
        </el-form-item>
        <el-form-item>
          <div class="form-submit-btn" @click="handleSearch">查询</div>
        </el-form-item>
      </el-form>
    </div>
    <TableBox class="table-box">
      <table class="table-head" cellpadding="0" cellspacing="0">
        <tr ref="tableTr">
          <th class="label" v-for="item in headList" :key="item.label" :width="item.width">{{ item.label }}</th>
        </tr>
      </table>
      <div class="scroll-y">
        <table class="table-content" cellpadding="0" cellspacing="0">
          <tr v-for="(item, i) in tableData" :key="item.id">
            <td class="val" width="50">{{ i+1 }}</td>
            <td class="val" width="50">{{ item.id }}</td>
            <td class="val" width="50">{{ item.area_name }}</td>
            <td class="val" width="100">{{ item.warningNum }}</td>
            <td class="val" width="100">{{ item.startTime }}</td>
            <td class="val" width="100">{{ item.endTime }}</td>
            <td class="val" width="100">{{ item.gridName }}</td>
            <td class="val" width="100">{{ item.status | filterStatus }}</td>
            <td class="val font-00FFF6" width="100" @click="handleDetail(item)">查看详情</td>
          </tr>
        </table>
      </div>
    </TableBox>
    <div style="text-align: center;padding-top: 10px">
      <el-pagination
        class="ai-pagination"
        popper-class="ai-pagination"
        @current-change="handleCurrentChange"
        :current-page="formInline.page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="formInline.limit"
        layout="total, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
    <DialogDetail :visible.sync="detailVisible" :info="info"></DialogDetail>
  </div>
</template>

<script>
import TableBox from '@/components/ClipBox/index.vue'
import {townshipList, warningStatus} from "../../../utils/common";
import {getArchivesPage} from "../../../api/warning";
import { baserUrl } from "../../../plugins/BsaeUrl";
import DialogDetail from "./components/DialogDetail";

export default {
  name: "index",
  components: { TableBox, DialogDetail },
  data () {
    return {
      detailVisible: false,
      info: {},
      total: 0,
      baserUrl: baserUrl,
      date: [],
      townshipList: townshipList,
      formInline: {
        town: '',
        fromDate: '',
        toDate: '',
        page: 1,
        limit: 10
      },
      tableData: [],
      headList: [
        {label: '序号', width: '50'},
        {label: 'id', width: '50'},
        {label: '所属乡镇', width: '50'},
        {label: '报警编号', width: '100'},
        {label: '开始时间', width: '100'},
        {label: '结束时间', width: '100'},
        {label: '区域负责人', width: '100'},
        {label: '状态', width: '100'},
        {label: '操作', width: '100'}
      ]
    }
  },
  mounted() {
    this.getList()
  },
  filters: {
    filterStatus (val) {
      const list = warningStatus.filter(x => {
        return x.value === val
      })
      return list[0] ? list[0].label : '-'
    }
  },
  methods: {
    changeDate (date) {
      if (date === null) {
        this.formInline.fromDate = ''
        this.formInline.toDate = ''
      } else {
        this.formInline.fromDate = date[0]
        this.formInline.toDate = date[1]
      }
    },
    handleSearch () {
      this.formInline.page = 1
      this.getList()
    },
    handleCurrentChange (val) {
      this.formInline.page = val
      this.getList()
    },
    getList () {
      getArchivesPage(this.formInline).then(res => {
        this.tableData = res.data.list
        this.total = res.data.totalCount
      })
    },
    handleDetail (item) {
      this.info = item
      this.detailVisible = true;
    }
  }
}
</script>

<style scoped lang="less">
  .warning-page{
    height: 100%;
    .search-box {
      padding-top: 28px;
      .form-input {
        width: 200px;
        height: 40px;
      }
      .form-select{
        /deep/ .el-input__inner{
          height: 40px;
        }
      }

      &::v-deep {
        .el-form-item__label {
          padding-right: 28px;
          font-size: 20px;
          color: #ffffff;
        }
      }
      .form-submit-btn {
        width: 150px;
        height: 50px;
        line-height: 50px;
        margin-top: -5px;
        margin-left: 25px;
        font-size: 17px;
        color: #00b2ff;
        letter-spacing: 12px;
        text-indent: 12px;
        text-align: center;
        background: url("~@/assets/img/settings/button-bg2.png") no-repeat
          center / 100% 100%;
        cursor: pointer;
      }
    }
    .table-box{
      width: 100%;
      height: calc(100% - 150px);
      .table-head {
        width: 100%;
        height: 50px;
        background-color: rgba(0, 255, 246, 0.3);

        th {
          padding: 0 10px;
          color: #00FFF6;
          font-size: 18px;
        }
      }

      .scroll-y {
        height: calc(100% - 50px);
        overflow-y: auto;
      }

      .table-content {
        width: 100%;
        text-align: center;
        table-layout: fixed;
        tr {
          height: 50px;
        }

        tr:nth-child(even) {
          background-color: rgba(0, 255, 246, 0.1);
        }

        td {
          padding: 0 10px;
          font-size: 16px;
          height: 50px;
          line-height: 50px;
          overflow:hidden; //超出的文本隐藏
          text-overflow:ellipsis; //用省略号显示
          white-space:nowrap; //不换行
        }
      }
    }
  }
</style>
